module.exports = __webpack_public_path__ + "static/media/roger-team-img-370x370.08e75687.jpg";